export { VuesaxBoldAndroid } from "./VuesaxBoldAndroid";
